import { Graph, Cell, Node, Path } from '@antv/x6';
import Hierarchy from '@antv/hierarchy';
//根节点
Graph.registerNode(
    'root',
    {
        inherit: 'rect',
        markup: [
            {
                tagName: 'rect',
                selector: 'body',
            },
            {
                tagName: 'image',
                selector: 'img',
            },
            {
                tagName: 'text',
                selector: 'label',
            },
        ],
        attrs: {
            body: {
                rx: 6,
                ry: 6,
                stroke: '#52c41a',
                fill: '#ccecc0',
                strokeWidth: 1,
            },
            img: {
                ref: 'body',
                refX: '100%',
                refY: '50%',
                refY2: -20,
                refX2: -25,
                width: 16,
                height: 16,
                'xlink:href':
                    'https://gw.alipayobjects.com/mdn/rms_43231b/afts/img/A*SYCuQ6HHs5cAAAAAAAAAAAAAARQnAQ',
                event: 'add:topic',
                class: 'topic-image',
            },
            label: {
                fontSize: 14,
                fill: '#666',
            },
        },
        ports: {
            groups: {
                left: {
                    position: 'right',
                    attrs: {
                        circle: {
                            r: 4,
                            magnet: true,
                            stroke: '#C2C8D5',
                            strokeWidth: 1,
                            fill: '#fff'
                        }
                    },
                }
            }
        }
    },
    true,
)

// 教学活动
Graph.registerNode(
    'topic',
    {
        inherit: 'rect',
        markup: [
            {
                tagName: 'rect',
                selector: 'body',
            },
            {
                tagName: 'image',
                selector: 'img',
            },
            {
                tagName: 'text',
                selector: 'label',
            },
        ],
        attrs: {
            body: {
                rx: 6,
                ry: 6,
                stroke: '#52c41a',
                fill: '#ccecc0',
                strokeWidth: 1,
            },
            img: {
                ref: 'body',
                refX: '100%',
                refY: '50%',
                refY2: -20,
                refX2: -25,
                width: 16,
                height: 16,
                'xlink:href':
                    'https://gw.alipayobjects.com/mdn/rms_43231b/afts/img/A*SYCuQ6HHs5cAAAAAAAAAAAAAARQnAQ',
                event: 'add:topic',
                class: 'topic-image',
            },
            label: {
                fontSize: 14,
                fill: '#666',
            },
        },
        ports: {
            groups: {
                left: {
                    position: 'left',
                    attrs: {
                        circle: {
                            r: 4,
                            magnet: true,
                            stroke: '#C2C8D5',
                            strokeWidth: 1,
                            fill: '#fff'
                        }
                    },
                },
                right: {
                    position: 'right',
                    attrs: {
                        circle: {
                            r: 4,
                            magnet: true,
                            stroke: '#C2C8D5',
                            strokeWidth: 1,
                            fill: '#fff'
                        }
                    }
                }
            }
        }
    },
    true,
)

// 任务
Graph.registerNode(
    'task',
    {
        inherit: 'rect',
        markup: [
            {
                tagName: 'rect',
                selector: 'body',
            },
            {
                tagName: 'text',
                selector: 'label',
            },
        ],
        attrs: {
            body: {
                rx: 6,
                ry: 6,
                stroke: '#1890ff',
                fill: '#d4e8fe',
                strokeWidth: 1,
            },
            label: {
                fontSize: 14,
                fill: '#666',
            },
        },
        ports: {
            groups: {
                left: {
                    position: 'left',
                    attrs: {
                        circle: {
                            r: 4,
                            magnet: true,
                            stroke: '#C2C8D5',
                            strokeWidth: 1,
                            fill: '#fff'
                        }
                    },
                },
                bottom: {
                    position: 'bottom',
                    attrs: {
                        circle: {
                            r: 4,
                            magnet: true,
                            stroke: '#C2C8D5',
                            strokeWidth: 1,
                            fill: '#fff'
                        }
                    }
                }
            }
        }
    },
    true,
)

// 连接器
Graph.registerConnector(
    'mindmap',
    (sourcePoint, targetPoint, routerPoints, options) => {
        const midX = sourcePoint.x + 10
        const midY = sourcePoint.y
        const ctrX = (targetPoint.x - midX) / 5 + midX
        const ctrY = targetPoint.y
        const pathData = `
                        M ${sourcePoint.x} ${sourcePoint.y}
                        L ${midX} ${midY}
                        Q ${ctrX} ${ctrY} ${targetPoint.x} ${targetPoint.y}
                    `
        return options.raw ? Path.parse(pathData) : pathData
    },
    true,
)

// 边
Graph.registerEdge(
    'mindmap-edge',
    {
        inherit: 'edge',
        connector: {
            name: 'mindmap',
        },
        attrs: {
            line: {
                targetMarker: '',
                stroke: '#A2B1C3',
                strokeWidth: 2,
            },
        },
        zIndex: 0,
    },
    true,
)

export function initGraph(dom, minimapContainer) {
    let graph;
    graph = new Graph({
        // clipboard: true,
        container: dom,
        autoResize: true,
        snapline: true,  //设置对齐线
        background: {
            color: '#fffff' // 设置画布背景颜色
        },
        grid: {
            size: 10, // 网格大小 10px
            visible: true // 渲染网格背景
        },
        connecting: {
            snap: true,
            allowBlank: false,
            allowLoop: false,
            highlight: true,
            connector: 'mindmap',
            connectionPoint: 'anchor',
            anchor: 'center',
            validateMagnet({ magnet }) {
                return magnet.getAttribute('port-group') !== 'top'
            },
            createEdge() {
                return graph.createEdge({
                    shape: 'mindmap-edge',
                    attrs: {
                        line: {
                            // strokeDasharray: '5 5'
                        }
                    },
                    zIndex: -1
                })
            }
        },
        selecting: {
            enabled: true,
            multiple: true,
            rubberEdge: true,
            rubberNode: true,
            modifiers: 'shift',
            rubberband: true
        },
        keyboard: {
            enabled: true,
        },
        panning: {
            enabled: true,
            // modifiers: 'shift',
        },
    })

    return graph;
}

const findItemFunc = (
    obj,
    id,
) => {
    if (obj.id === id) {
        return {
            parent: null,
            node: obj,
        }
    }
    const { children } = obj
    if (children) {
        for (let i = 0, len = children.length; i < len; i++) {
            const res = findItemFunc(children[i], id)
            if (res) {
                return {
                    parent: res.parent || obj,
                    node: res.node,
                }
            }
        }
    }
    return null
}

export function findItem(obj, id) {
    return findItemFunc(obj, id);
}

export function addChildNode(data, {
    curId,
    id = new Date().getTime()
    , type = 'topic'
    , label
    , appendData = {}
}) {
    const res = findItem(data, curId)
    const dataItem = res?.node
    if (dataItem) {
        let item = null
        const length = dataItem.children ? dataItem.children.length : 0
        let str = label ?? `分支节点${length + 1}`;
        appendData.id = id;
        item = {
            id,
            type,
            label: str,
            width: numbericWidth(str),
            height: 40,
            appendData,
        }
        if (item) {
            if (dataItem.children) {
                dataItem.children.push(item)
            } else {
                dataItem.children = [item]
            }
            return item
        }
    }
    return null
}

export function removeNode(data, id) {
    const res = findItemFunc(data, id);
    const dataItem = res?.parent
    if (dataItem && dataItem.children) {
        const { children } = dataItem
        const index = children.findIndex((item) => item.id === id)
        return children.splice(index, 1)
    }
    return null
}

export function graphRender(data, graph) {
    const result = Hierarchy.mindmap(data, {
        direction: 'TB',
        getHeight(d) {
            return d.height
        },
        getWidth(d) {
            return d.width
        },
        getHGap() {
            return 40
        },
        getVGap() {
            return 20
        },
        getSide: () => {
            return 'right'
        },
    })
    const cells = []
    const traverse = (hierarchyItem) => {
        if (hierarchyItem) {
            const { data, children } = hierarchyItem
            let ports = data.type === 'topic' ?
                [
                    { id: `port-${data.id}-left`, group: "left" },
                    { id: `port-${data.id}-right`, group: "right" },
                ] :
                [{ id: `port-${data.id}-left`, group: "left", },]
            cells.push(
                graph.createNode({
                    id: data.id,
                    shape: data.type,
                    x: hierarchyItem.x,
                    y: hierarchyItem.y,
                    width: data.label ? data.label.length * 16 : data.width,
                    height: data.height,
                    label: data.label,
                    type: data.type,
                    ports,
                }),
            )
            if (children) {
                children.forEach((item) => {
                    const { id, data } = item
                    cells.push(
                        graph.createEdge({
                            shape: 'mindmap-edge',
                            source: {
                                cell: hierarchyItem.id,
                                anchor: {
                                    name: 'right',
                                    args: {
                                        dx: -16,
                                    },
                                }
                            },
                            target: {
                                cell: id,
                                anchor: {
                                    name: 'left',
                                },
                            },
                        }),
                    )
                    traverse(item)
                })
            }
        }
    }
    traverse(result)
    graph.resetCells(cells)
}

export function numbericWidth(str = '') {
    let width;
    if (str.length > 8) {
        width = str.length / 8 * 160;
    } else {
        width = 160;
    }
    return width;
}